import { useState, type FormEvent } from "react";

import { requestPasswordReset, resetPassword } from "../data/auth";
import { PasswordField } from "./PasswordField";

export const PasswordRecoveryPage = () => {
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [password, setPassword] = useState("");
  const [requested, setRequested] = useState(false);
  const [message, setMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleRequest = async (event: FormEvent) => {
    event.preventDefault();
    setSubmitting(true);
    setMessage("");
    try {
      await requestPasswordReset(email);
      setRequested(true);
      setMessage("Enviamos um código de recuperação para o seu e-mail.");
    } catch (reason) {
      setMessage(
        reason instanceof Error
          ? reason.message
          : "Não foi possível enviar o código.",
      );
    } finally {
      setSubmitting(false);
    }
  };

  const handleReset = async (event: FormEvent) => {
    event.preventDefault();
    setSubmitting(true);
    setMessage("");
    try {
      await resetPassword(email, code, password);
      window.location.assign("/app/login?reset=success");
    } catch (reason) {
      setMessage(
        reason instanceof Error
          ? reason.message
          : "Não foi possível redefinir a senha.",
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="miboard-auth-page">
      <form
        className="miboard-auth-card"
        onSubmit={requested ? handleReset : handleRequest}
      >
        <img
          src="/image/Logo%20Miboard.png"
          alt="MiBoard"
          className="miboard-auth-logo"
        />
        <h1>{requested ? "Redefinir senha" : "Esqueceu sua senha?"}</h1>
        <p className="miboard-auth-description">
          {requested
            ? "Informe o código recebido por e-mail e escolha uma nova senha."
            : "Informe seu e-mail para receber um código de recuperação."}
        </p>
        <label className="miboard-auth-label">
          E-mail
          <input
            required
            type="email"
            value={email}
            disabled={requested}
            onChange={(event) => setEmail(event.target.value)}
            className="miboard-auth-input"
          />
        </label>
        {requested && (
          <>
            <label className="miboard-auth-label">
              Código recebido
              <input
                required
                inputMode="numeric"
                pattern="[0-9]{6}"
                maxLength={6}
                value={code}
                onChange={(event) =>
                  setCode(event.target.value.replace(/\D/g, ""))
                }
                className="miboard-auth-input"
              />
            </label>
            <label className="miboard-auth-label">
              Nova senha
              <PasswordField
                required
                minLength={8}
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                inputClassName="miboard-auth-input"
              />
            </label>
          </>
        )}
        {message && <p className="miboard-auth-message">{message}</p>}
        <button
          className="miboard-auth-submit"
          type="submit"
          disabled={submitting}
        >
          {submitting
            ? "Aguarde..."
            : requested
            ? "Redefinir senha"
            : "Enviar código"}
        </button>
        <p className="miboard-auth-link">
          <a href="/app/login">Voltar para entrar</a>
        </p>
      </form>
    </main>
  );
};
